// There's a lot of awful warnings surrounding the useEffect hook when we only want something to happen on mount.
// So this is an adapter for the "on mount" effect

import{ EffectCallback, useEffect } from "react"

export function useOnMount(effect: EffectCallback) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(effect, [])
}